export const ACCREDITATION_HISTORICAL = '/accreditationHistorical';
export const SESSION_AUDIT = '/session-audit';


export const ACCREDITATIONS_APPLICATIONS = '/accreditations/applications';
